import React, { useState, useEffect } from "react";
import { set_product_details } from "../../../redux/actions/ProductsAction";
import { set_variants } from "../../../redux/actions/VariantsAction";
import { connect } from "react-redux";
import { Table } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import { apiJson } from "../../../api/Api";
import { Redirect } from "react-router";
import { toast } from "react-toastify";
import Pagination from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import "rc-dropdown/assets/index.css";
import { getDesktopImage } from "../../../utils/utils";
const TableList = (props) => {
  const [values, setValues] = useState("");

  useEffect(() => {
    setValues(props.List);
  }, [props.List]);

  const handlePageChange = (pageNumber) => {
    props.pageChange(pageNumber.selected + 1);
  };
  const [dropdown, setdropdown] = useState({
    value: false,
    id: -1,
  });

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    setisDeleteClick(false);
  }, []);
  const [isEditClick, setisEditClick] = useState(false);
  const [isViewClick, setisViewClick] = useState(false);
  const [isDeleteClick, setisDeleteClick] = useState(false);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      setisDeleteClick(false);
      apiJson.products.deleteProduct(dropdown.id).then((response) => {
        if (response.success) {
          setisDeleteClick(true);
        } else if (!response.status) {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
    }
  };

  const menuItems = [
    <MenuItem
      key="2"
      onClick={() => {
        setisViewClick(true);
      }}
      style={{ cursor: "pointer" }}
    >
      View
    </MenuItem>,
    props.store?.can_manage_product && (
      <MenuItem
        key="4"
        onClick={() => setisEditClick(true)}
        style={{ cursor: "pointer" }}
      >
        Edit
      </MenuItem>
    ),
    <MenuItem key="1" onClick={handleDelete} style={{ cursor: "pointer" }}>
      Delete
    </MenuItem>
  ];
  const menu = (
    <Menu
      className="menu"
      style={{
        width: "100px",
        textAlign: "center",
      }}
    >
      {menuItems}
    </Menu>
  );

  return (
    <div className="table-responsive">
      <Table hover className="overflow-auto borderless">
        <thead style={{ borderBottom: "#F5F5F9" }}>
          <tr className="table-head">
            <td className="">Product Image</td>
            <td className="">Name</td>
            <td className="">Status</td>
            <td className="">Actions</td>
          </tr>
        </thead>
        <tbody>
          {values !== "" &&
            values.map((product) => {
              const id = product.id;
              return (
                <tr key={product.id}>
                  <td className="product-image">
                    {product?.featured_image ? (
                      <img
                        src={getDesktopImage(
                          product?.featured_image_resized,
                          product?.featured_image
                        )}
                        style={{
                          width: "auto",
                          maxWidth: "80px",
                          height: "80px",
                        }}
                        alt=""
                      />
                    ) : (
                      <span>No Image</span>
                    )}
                  </td>
                  <td className="name-text">{product.name_en}</td>
                  <td>
                    <div className="status-text">{product.status}</div>
                  </td>
                  <td className="">
                    <div className="action-wrapper">
                      <Dropdown
                        className="dropdown-for-send"
                        overlay={menu}
                        overlayClassName="overlay-class"
                      >
                        <button>
                          <BsThreeDots
                            style={{ cursor: "pointer" }}
                            onMouseEnter={() =>
                              setdropdown({
                                value:
                                  id === dropdown.id ? !dropdown.value : true,
                                id: id,
                              })
                            }
                          />
                        </button>
                      </Dropdown>
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {props.pagination?.total_pages && values.length > 0 && (
        <div
          className="d-flex justify-content-center mb-4 w-100"
          style={{ direction: "ltr" }}
        >
          <Pagination
            direction="ltr"
            previousLabel={<FaChevronLeft color="#404553" />}
            nextLabel={<FaChevronRight color="#404553" />}
            pageCount={props.pagination?.total_pages}
            onPageChange={handlePageChange}
            pageRangeDisplayed={2}
            forcePage={parseInt(props?.pagination?.page) - 1}
            containerClassName="pagination"
            pageClassName="ms-3 me-3 ps-3 pe-3 pt-2 pb-2"
            activeClassName={
              "ms-3 me-3 ps-1 pe-1 text-primary border border-primary font-weight-bold rounded bg-white"
            }
            nextClassName="bg-white ps-3 pe-3 pt-2 pb-2"
            previousClassName="bg-white ps-3 pe-3 pt-2 pb-2"
          />
        </div>
      )}
      {isEditClick ? (
        <Redirect
          push
          to={{
            pathname: `/vendor/product/${dropdown.id}/edit`,
            state: { id: dropdown.id },
          }}
        />
      ) : isViewClick ? (
        <Redirect
          push
          to={{
            pathname: `/vendor/product/${dropdown.id}/view`,
            state: { id: dropdown.id },
          }}
        />
      ) : (
        isDeleteClick && (
          <Redirect
            push
            to={{
              pathname: "/vendor/product-catalog",
              state: { name: `delete${dropdown.id}` },
            }}
          />
        )
      )}
    </div>
  );
};

const mapDispatchTopProps = { set_product_details, set_variants };

export default connect(null, mapDispatchTopProps)(TableList);
